import { apiService } from 'core/services/apiService';

export interface WorkingHourRequest {
  workplace: string;
  day: string;
  openAt: string;
  closeAt: string;
}

export interface WorkingHourResponse {
  "@context": string;
  "@id": string;
  "@type": string;
  workplace: {
    "@context": string;
    "@id": string;
    "@type": string;
    id: number;
    name: string;
  };
  day: {
    "@context": string;
    "@id": string;
    "@type": string;
    id: number;
    label: string;
    locale: string;
  };
  openAt: string;
  closeAt: string;
}

export const createWorkingHour = async (data: WorkingHourRequest): Promise<WorkingHourResponse> => {
  const response = await apiService.post('/workplace-working-hours', data);
  return response.data;
};

export const updateWorkingHour = async (id: string, data: WorkingHourRequest): Promise<WorkingHourResponse> => {
  const response = await apiService.put(`/workplace-working-hours/${id}`, data);
  return response.data;
};

export const deleteWorkingHour = async (id: string): Promise<void> => {
  await apiService.delete(`/workplace-working-hours/${id}`);
};

export const getWorkingHours = async (workplaceId: string): Promise<WorkingHourResponse[]> => {
  const { ['hydra:member']: members } = await apiService.responseHandler(
    await apiService.get(`/workplace-working-hours?workplace=${workplaceId}`)
  );
  return members;
};

export interface WorkplaceWorkingHoursResponse {
  "@context": string;
  "@id": string;
  "@type": string;
  totalItems: number;
  member: WorkingHourResponse[];
}

export const fetchWorkplaceWorkingHours = async (workplaceId?: number): Promise<WorkplaceWorkingHoursResponse> => {
  const url = workplaceId 
    ? `/workplace-working-hours?pagination=false&workplace=${workplaceId}`
    : `/workplace-working-hours?page=1&itemsPerPage=30&pagination=false`;
  const response = await apiService.get<WorkplaceWorkingHoursResponse>(url);
  return response.data;
};